/**
 * globalVar
 */
interface GlobalState {
  common: {
    isModalOpen: boolean;
  },
  pageHome: {
    isLoading: boolean;
    sectionNumber: number;
    anchorId: string | null;
  };
}
export let globalState: GlobalState = {
  common: {
    isModalOpen: false,
  },
  pageHome: {
    isLoading: true,
    sectionNumber: 0,
    anchorId: null,
  }
}

/**
 * IE対策
 */
import './modules/ie11';

/**
 * スマホ100vh対策
 */
import { ViewportModule } from './modules/viewport';
const $viewport = new ViewportModule.Service();

/**
 * スムーズスクロール
 * 別ページからのアンカーリンク
 */
import { SmoothScrollModule } from './modules/smooth_scroll';
const $smoothScrollModule = new SmoothScrollModule.Service();

/**
 * スクロールイベント
 * 「.js__scroll」に対して処理をする
 */
import { ScrollEventModule } from './modules/scroll_event';
const $scrollEventModule = new ScrollEventModule.Service();

/**
 * トグルイベント
 * 「.js__toggle」に対して処理をする
 * data-target data-toggleclass の設定が必要
 */
import { ToggleActionModule } from './modules/toggle_action';
const $toggleActionModule = new ToggleActionModule.Service();

/**
 * 読み込み完了
 */
import { LoadModule } from './modules/load';
const $load = new LoadModule.Service();

/**
 * canvasアニメーション
 */
import { CanvasModule } from './components/top/canvas';
const $canvas = new CanvasModule.Service();

/**
 * ヘッダー
 */
import { HeaderModule } from './components/header/header';
const $header = new HeaderModule.Service();

/**
 * セクションスクロール
 */
import { SectionScroll02Module } from './components/top/sectionScroll02';
const $sectionScroll = new SectionScroll02Module.Service();

/**
 * テキストアニメーション
 */
import { UiTextAnimationModule } from './components/top/textAnimation';
const $textAnimation = new UiTextAnimationModule.Service();

/**
 * スライダー
 */
import { UiSliderModule } from './components/top/slider';
const $slider = new UiSliderModule.Service();

/**
 * モーダル
 */
import { CharacterModalModule } from './components/top/characterModal';
const $modal01 = new CharacterModalModule.Service();

/**
 * モーダル
 */
import { YoutubeModalModule } from './components/top/youtubeModal';
const $modal02 = new YoutubeModalModule.Service();

/**
 * マウスストーカー
 */
import { MouseStalkerModule } from './components/top/mouseStalker';
const $mouseStalker = new MouseStalkerModule.Service();

